

/* Calculate distance between two lat/lng points in KM */
export const haversineDistance = (lat1, lon1, lat2, lon2) => {
  if (
    !Number.isFinite(lat1) ||
    !Number.isFinite(lon1) ||
    !Number.isFinite(lat2) ||
    !Number.isFinite(lon2)
  ) {
    return null;
  }

  const R = 6371; // Earth radius in KM
  const toRad = (deg) => (deg * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) ** 2;

  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

/* Calculate bearing angle (for marker rotation) */

export const calculateBearing = (start, end) => {
  if (!start || !end) return 0;

  const toRad = (deg) => (deg * Math.PI) / 180;
  const toDeg = (rad) => (rad * 180) / Math.PI;

  const lat1 = toRad(start[0]);
  const lon1 = toRad(start[1]);
  const lat2 = toRad(end[0]);
  const lon2 = toRad(end[1]);

  const dLon = lon2 - lon1;

  const y = Math.sin(dLon) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

  return (toDeg(Math.atan2(y, x)) + 360) % 360;
};

/* Estimate ETA in minutes */
export const calculateETA = (distanceKm, speedKmph = 25) => {
  if (!Number.isFinite(distanceKm) || distanceKm <= 0) return null;
  return Math.round((distanceKm / speedKmph) * 60);
};

/* Generate smooth curved polyline between two points */
export const generateCurve = (start, end, points = 20) => {
  if (!start || !end) return [];

  return Array.from({ length: points }, (_, i) => {
    const t = i / (points - 1);
    return [
      start[0] + (end[0] - start[0]) * t,
      start[1] +
        (end[1] - start[1]) * t +
        Math.sin(t * Math.PI) * 0.0004,
    ];
  });
};

/* Check arrival within radius (KM) */
export const hasArrived = (distanceKm, radiusKm = 0.05) => {
  if (!Number.isFinite(distanceKm)) return false;
  return distanceKm <= radiusKm;
};
